import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfColor,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { ESymbol } from '../../pdf/draw/symbol';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';
import '../../pdf/draw/shapes';

/**
 * Fotografie (Photography) - Film strip / camera layout
 *
 * Layout: Dynamic pages with portrait A4.
 * Page 1: Camera icon spans 2 columns at top, 2x2 image grid below.
 * Pages 2+: 2x3 image grid per page.
 * Film strip cells have sprocket holes on sides.
 *
 * Migrated from C# EduFrame.Img10.Generators.Fotografie
 */
export class Fotografie implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const side = PdfUnit.FromMillimeters(10);
    const space = PdfUnit.FromMillimeters(2);

    const { origin, size } = calcOrigin(2, 3, margin, PdfSize.A4);
    const count = Math.round(size.height / side);
    const sz0 = { width: side, height: size.height / count };
    const sz1 = { width: sz0.width - 2 * space, height: sz0.height - space };
    const round = PdfUnit.FromMillimeters(3);

    const slotsPerFirstPage = 4;
    const slotsPerPage = 6;
    const totalSlots = opts.list.length;
    const pageCount = 1 + Math.ceil(Math.max(0, totalSlots - slotsPerFirstPage) / slotsPerPage);

    for (let pageIdx = 0; pageIdx < pageCount; pageIdx++) {
      const page = pdf.addPage();

      for (let y = 0; y < 3; y++) {
        for (let x = 0; x < 2; x++) {
          let index: number;
          let isCameraCell = false;

          if (pageIdx === 0 && y === 0) {
            if (x === 0) {
              isCameraCell = true;
            } else {
              continue;
            }
            index = -1;
          } else if (pageIdx === 0) {
            index = (y - 1) * 2 + x;
          } else {
            index = slotsPerFirstPage + (pageIdx - 1) * slotsPerPage + y * 2 + x;
          }

          if (index >= totalSlots) continue;

          const rect = new PdfRect(
            origin.x + x * size.width,
            origin.y + y * size.height,
            size.width,
            size.height
          );

          if (isCameraCell) {
            const cameraRect = new PdfRect(rect.x, rect.y, size.width * 2, size.height);
            page.drawSymbol(ESymbol.Camera1, PdfBrush.Black, cameraRect, 350, ETextAlign.Center);
            continue;
          }

          const labelRect = new PdfRect(
            rect.x + side,
            rect.y + 2 * sz0.height,
            rect.width - 2 * side,
            rect.height - 2 * sz0.height
          );

          const rr1 = new PdfRect(rect.x, rect.y, side, rect.height);
          const rr2 = new PdfRect(rect.right - side, rect.y, side, rect.height);

          // page.drawString(`${index}`, GUtil.baseFont, PdfBrush.Black, null, rect, ETextAlign.Center);
          page.drawLabel(opts.list[index].left, { rect: labelRect });

          page.drawRectangle(null, PdfBrush.Black, rr1);
          page.drawRectangle(null, PdfBrush.Black, rr2);

          for (let i = 0; i < count; i++) {
            const r1 = new PdfRect(
              rect.x + space,
              rect.y + i * sz0.height + space / 2,
              sz1.width,
              sz1.height
            );
            const r2 = new PdfRect(
              rect.right - side + space,
              rect.y + i * sz0.height + space / 2,
              sz1.width,
              sz1.height
            );

            page.drawRoundedRectangle(null, PdfBrush.White, r1, round);
            page.drawRoundedRectangle(null, PdfBrush.White, r2, round);
          }

          page.drawRectangle(GUtil.cutPen, null, rect);
        }
      }
    }
  }
}
